import {
  ChangeDetectionStrategy,
  Component,
  Injector,
  NgZone,
  OnChanges,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ReactiveFormSearchableDropDownComponent } from '@mobilefirstdev/reactive-form';
import { window } from 'ngx-bootstrap/utils';
import { BasicAddEditSmartFilterFormViewModel } from './basic-add-edit-smart-filter-form-view-model';
import { BaseSmartFilterFormComponent } from '../base-smart-filter-form';
import { SmartFiltersDomainModel } from '../../../../../domainModels/smart-filters-domain-model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalEditSmartFilterCategory } from '../../../../../modals/modal-edit-smart-filter-category';

@Component({
  selector: 'app-basic-add-edit-smart-filter-form',
  templateUrl: './basic-add-edit-smart-filter-form.component.html',
  styleUrls: ['./basic-add-edit-smart-filter-form.component.scss'],
  providers: [BasicAddEditSmartFilterFormViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BasicAddEditSmartFilterFormComponent extends BaseSmartFilterFormComponent implements OnChanges {
  @ViewChild('primarySort') primarySortInput: ReactiveFormSearchableDropDownComponent;
  @ViewChild('secondarySort') secondarySortInput: ReactiveFormSearchableDropDownComponent;
  @ViewChild('categoryDropDown') categoryDropDown: ReactiveFormSearchableDropDownComponent;

  public dropdownSmartFilterCategories$ = this.smartFiltersDomainModel.smartFilterCategories$;
  public dropdownSmartFilterSystemIdentifiers$ = window?.types?.smartFilterSystemIdentifiers$;

  private selectedPrimarySortOption = new BehaviorSubject<string>(null);

  // The searchable drop-down renders its selection from internal state, so a newly created category is selected
  // through programmaticallyChangeValue rather than by writing to the form control.
  private _programmaticCategoryId = new BehaviorSubject<string>(undefined);
  public programmaticCategoryId$ = this._programmaticCategoryId as Observable<string>;
  connectToProgrammaticCategoryId = (categoryId: string) => this._programmaticCategoryId.next(categoryId);

  private listenToItemCount = this.viewModel.itemCount$.subscribeWhileAlive({
    owner: this,
    next: ic => {
      if (!ic) {
        this.primarySortInput?.clear();
        this.secondarySortInput?.clear();
      }
    }
  });

  private listenToPrimarySortDropDown = this.selectedPrimarySortOption.subscribeWhileAlive({
    owner: this,
    next: op => {
      if (!op) {
        this.secondarySortInput?.clear();
      }
    }
  });

  constructor(
    public viewModel: BasicAddEditSmartFilterFormViewModel,
    private smartFiltersDomainModel: SmartFiltersDomainModel,
    private ngZone: NgZone,
    private ngbModel: NgbModal,
    private injector: Injector
  ) {
    super();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.bindTo) {
      this.viewModel.connectToSmartFilter(this.bindTo);
      this.viewModel.setItemCount(this.bindTo.itemCount);
      this.primarySortDropdownChanged(this.bindTo.primarySort);
    }
    if (changes.isEditing) this.viewModel.connectToIsEditing(this.isEditing);
    if (changes.isViewOnly) this.viewModel.connectToIsViewOnly(this.isViewOnly);
  }

  public primarySortDropdownChanged(sortOption: string) {
    this.selectedPrimarySortOption.next(sortOption);
    this.viewModel.primarySortDropdownChanged(sortOption);
  }

  newCategoryClicked() {
    ModalEditSmartFilterCategory.open(this.ngZone, this.ngbModel, this.injector, null, createdCategory => {
      this.dropdownSmartFilterCategories$.firstNotNull$().subscribe(() => {
        setTimeout(() => {
          this.bindTo.categoryId = createdCategory.id;
          this.connectToProgrammaticCategoryId(createdCategory.id);
          this.categoryDropDown.getSelfAsFormItem().markAsDirty();
        }, 500);
      });
    });
  }
}
